import { FETCH_PROFILES, FETCH_GROUPS, LOAD_PROFILES, LOAD_GROUPS } from '../Actions/FilterLists'

const initialState = {
  profiles: [],
  groups: []
}

/**
  * FilterReducer
  * @desc Filter State handler
  * @param {Object} state
  * @param {action} action
  * @return {Object} state updated state
*/
export default function FilterReducer (state, action) {
  if (typeof state === 'undefined') {
    return initialState
  }
  switch (action.type) {
    case FETCH_PROFILES:
      return Object.assign({}, state, { profiles: [Object.assign({}, { _id: '0', name: 'Loading', groups: [] })] })
    case LOAD_PROFILES:
      return Object.assign({}, state, { profiles: action.data.allAppProfiles })
    case FETCH_GROUPS:
      return Object.assign({}, state, { groups: [Object.assign({}, { _id: '0', name: 'Loading' })] })
    case LOAD_GROUPS:
      return Object.assign({}, state, { groups: action.data.allGroups })
    default:
      return state
  }
}
